import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import Link from '../../routing/components/Link';

class ArticleLanguages extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    let self = this;
    let {articleVersions} = this.props;

    if (articleVersions.item.length === 0) {
      return <em><FormattedMessage id="noVersions"/></em>;
    }

    return (
      <div>
        {articleVersions.item.map(item =>
          <div key={item.attributes.language}>
            <Link url={self.props.location.pathname.replace(/index$/, item.attributes.language)}>
              <FormattedMessage id={item.attributes.language}/>
            </Link>
          </div>
        )}
      </div>
    );
  }
}

ArticleLanguages.propTypes = {
  articleVersions: PropTypes.object
};

function mapStateToProps(state) {
  const {articleVersions} = state;
  return {
    articleVersions
  };
}

export default connect(mapStateToProps)(ArticleLanguages);



/** WEBPACK FOOTER **
 ** ./src/modules/articles/components/ArticleLanguages.js
 **/